import React, { useEffect, useState } from "react";
import { Box, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";

import CustomCardWithBorder from "../../../../../components/CustomCardWithBorder";
import ModuleWiseReport from "./ModuleWiseReport";
import CustomSelectField from "../../../../../components/customFields/CustomSelectField";
import {
  DashboardStudentExamData,
  getPerformanceCamparisonData,
  getPerformanceOverallData,
  getRealTestTestTypes,
} from "../../../Api/DashboardApi";
import OverAllWiseProgress from "./OverAllWiseProgress";
import ComparisonProgressChart from "./LastThreeComaparison";

export default function PerformanceReport() {
  const [value, setValue] = React.useState("module");

  const userId = localStorage.getItem("userId");
  const [testTypeList, setTestTypeList] = useState([]);
  const [testType, setTestType] = useState(null);

  const [dashBoardData, setDashBoardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [testTypeData, setTestTYpeData] = useState(null);
  const [overallData, setOverallData] = useState([]);
  const [overallLoading, setOverallLoading] = useState(true);
  const [comparisonData, setComparisonData] = useState([]);
  const [comparisonLoading, setComparisonLoading] = useState(true);

  // tabs
  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      setValue(newValue);
    }
  };
  // fetch test Type list

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getRealTestTestTypes(userId);
        const Responsedata = data?.data;
        setTestTypeList(Responsedata);
        const firstId = Responsedata[0];
        setTestType(firstId?.sl_no);
      } catch (err) {
        console.error("Could not fetch test types");
        setTestTypeList([]);
      }
    };
    fetchData();
  }, []);

  // select test type
  const handleTestTypeChange = (e) => {
    const selected = e.target.value; // contains the whole object

    setTestType(selected);
  };

  useEffect(() => {
    const selectedOBJ = testTypeList?.find((i) => i.sl_no === testType);
    setTestTYpeData(selectedOBJ);
  }, [testType]);

  // fetch dashboard data
  const handleFetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await DashboardStudentExamData({
        studentStmId: userId,

        examType: testTypeData?.exam_portal_id,
        subCat: testTypeData?.sub_exam_portal_id,
      });

      if (response.code === 200) {
        setDashBoardData(response?.finalData);

        setLoading(false);
      } else {
        setDashBoardData([]);

        setLoading(false);
      }
    } catch (error) {
      setDashBoardData([]);
      setLoading(false);
    }
  };
  // fetch dashboard data
  useEffect(() => {
    if (testTypeData && userId && value == "module") {
      handleFetchDashboardData();
    }
  }, [testTypeData, userId, value]);

  // fetch overall data
  const handlefetchOverallData = async () => {
    try {
      setOverallLoading(true);
      const response = await getPerformanceOverallData({
        studentStmId: userId,

        examType: testTypeData?.exam_portal_id,
        subCat: testTypeData?.sub_exam_portal_id,
      });

      if (response.code === 200) {
        setOverallData(response);

        setOverallLoading(false);
      } else {
        setOverallData([]);

        setOverallLoading(false);
      }
    } catch (error) {
      setDashBoardData([]);
      setOverallLoading(false);
    }
  };
  // fetch overall data
  useEffect(() => {
    if (testTypeData && userId && value == "overall") {
      handlefetchOverallData();
    }
  }, [testTypeData, userId, value]);

  // fetch comparison data

  const handlefetchCamparisonData = async () => {
    try {
      setComparisonLoading(true);
      const response = await getPerformanceCamparisonData({
        studentStmId: userId,

        examType: testTypeData?.exam_portal_id,
        subCat: testTypeData?.sub_exam_portal_id,
      });

      if (response.code === 200) {
        setComparisonData(response);

        setComparisonLoading(false);
      } else {
        setComparisonData([]);

        setComparisonLoading(false);
      }
    } catch (error) {
      setDashBoardData([]);
      setOverallLoading(false);
    }
  };
  // fetch comparison data
  useEffect(() => {
    if (testTypeData && userId && value === "test_comparison") {
      handlefetchCamparisonData();
    }
  }, [testTypeData, userId, value]);
  return (
    <CustomCardWithBorder boxShadow={true} height="380px">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={8}>
          <Box
            sx={{
              backgroundColor: "#f5f5f5",
              borderRadius: "12px",
              padding: "4px",
              display: "inline-flex",
            }}
          >
            <ToggleButtonGroup
              value={value}
              exclusive
              onChange={handleChange}
              sx={{
                fontFamily: "Inter",

                "& .MuiToggleButton-root": {
                  border: "none",
                  borderRadius: "5px !important",
                  padding: "6px 16px",
                  textTransform: "none",
                  fontWeight: 600,
                  color: "#000000",
                  background: "#ffffff",
                  fontSize: "12px",
                  fontFamily: "Inter",
                },
                "& .Mui-selected": {
                  backgroundColor: "#572575 !important",
                  color: "#fff !important",
                  fontWeight: 700,
                },
              }}
            >
              <ToggleButton value="module">Module Report</ToggleButton>

              <ToggleButton value="overall">Overall Report</ToggleButton>

              <ToggleButton value="test_comparison">
                Test Comparison
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ textAlign: "right" }}>
          <CustomSelectField
            color="#222222"
            ExpandMoreIconColor="#222222"
            dafualtValue="Select Test Type"
            fontWeight={600}
            borderColor="#EEEEEE"
            fontSize="12px"
            borderRadius="8px"
            // boxShadow={true}
            options={testTypeList}
            getOptionLabel={(opt) =>
              `${opt?.test_type_name}${
                opt?.sub_test_type_name ? ` ( ${opt.sub_test_type_name} )` : ""
              }`
            }
            getOptionValue={(opt) => opt?.sl_no}
            value={testType}
            onChange={handleTestTypeChange}
          />
        </Grid>

        {value === "module" && (
          <Grid item xs={12} mt={1}>
            <ModuleWiseReport
              dashBoardData={dashBoardData}
              loading={loading}
              testTypeData={testTypeData}
            />
          </Grid>
        )}

        {value === "overall" && (
          <Grid item xs={12} mt={1}>
            <OverAllWiseProgress
              overallData={overallData}
              loading={overallLoading}
              testTypeData={testTypeData}
            />
          </Grid>
        )}

        {value === "test_comparison" && (
          <Grid item xs={12} mt={1}>
            <ComparisonProgressChart
              overallData={comparisonData}
              loading={comparisonLoading}
              testTypeData={testTypeData}
            />
          </Grid>
        )}
      </Grid>
    </CustomCardWithBorder>
  );
}
